import { render, staticRenderFns } from "./personalFriend.vue?vue&type=template&id=bcfeb24e&scoped=true"
import script from "./personalFriend.vue?vue&type=script&lang=js"
export * from "./personalFriend.vue?vue&type=script&lang=js"
import style0 from "./personalFriend.vue?vue&type=style&index=0&id=bcfeb24e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfeb24e",
  null
  
)

export default component.exports